import React from 'react';
import { ArrowUpRight, Quote, Star } from 'lucide-react';
import { FadeIn } from './ScrollReveal';
import { customerReviews } from '../data/customerReviews';

const GoogleIcon = ({ className = '' }) => (
  <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09Z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23Z" />
    <path fill="#FBBC05" d="M5.84 14.09A6.6 6.6 0 0 1 5.49 12c0-.73.13-1.43.35-2.09V7.07H2.18A11 11 0 0 0 1 12c0 1.78.43 3.45 1.18 4.93l3.66-2.84Z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15A10.96 10.96 0 0 0 2.18 7.07l3.66 2.84A6.52 6.52 0 0 1 12 5.38Z" />
  </svg>
);

const Stars = () => (
  <div className="flex gap-1" aria-label="5 von 5 Sternen">
    {[0, 1, 2, 3, 4].map((star) => (
      <Star key={star} className="h-4 w-4 fill-amber-400 text-amber-400" />
    ))}
  </div>
);

const GoogleReviews = () => (
  <section id="google-reviews" className="bg-stone-950 py-20 text-white sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <FadeIn>
        <div className="mb-10 flex flex-col gap-6 lg:mb-12 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm text-stone-300">
              <GoogleIcon className="h-5 w-5" />
              Kundenbewertungen
            </div>
            <h2 className="text-3xl font-semibold tracking-tight sm:text-4xl lg:text-5xl">
              Drei Stimmen. Ein klares Ergebnis.
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-stone-400">
              Saubere Arbeit, verlässliche Absprachen und Ergebnisse, die langfristig überzeugen.
            </p>
          </div>

          <div className="flex items-center gap-4 rounded-2xl border border-white/10 bg-white/5 px-5 py-4">
            <div className="text-4xl font-semibold">5,0</div>
            <div>
              <Stars />
              <p className="mt-1 text-sm text-stone-400">3 Kundenstimmen</p>
            </div>
          </div>
        </div>
      </FadeIn>

      <div className="grid gap-5 lg:grid-cols-3">
        {customerReviews.map((review, index) => (
          <FadeIn key={review.name} delay={index * 100}>
            <article className="flex h-full flex-col rounded-2xl border border-white/10 bg-white p-6 text-stone-900 shadow-2xl shadow-black/10 sm:p-7">
              <div className="mb-8 flex items-start justify-between gap-4">
                <Stars />
                <Quote className="h-8 w-8 text-primary-200" aria-hidden="true" />
              </div>
              <blockquote className="flex-1 text-base leading-7 text-stone-700">
                „{review.text}“
              </blockquote>
              <footer className="mt-8 border-t border-stone-100 pt-5">
                <p className="font-semibold text-stone-900">{review.name}</p>
                <p className="mt-1 text-sm text-stone-500">{review.project}</p>
              </footer>
            </article>
          </FadeIn>
        ))}
      </div>

      <div className="mt-8 flex justify-center">
        <a
          href="https://www.google.com/search?q=Fliesen+Jarek+Cuxhaven+Bewertungen"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 text-sm font-semibold text-white transition-colors hover:text-primary-300"
        >
          Bewertungen bei Google ansehen
          <ArrowUpRight className="h-4 w-4" />
        </a>
      </div>
    </div>
  </section>
);

export default GoogleReviews;
